import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TemplatesTab } from '../../../../components/admin/TemplatesTab';

export const Route = createFileRoute('/_auth/admin/templates/')({
  component: AdminTemplatesPage,
});

function AdminTemplatesPage() {
  const { t } = useTranslation();
  return (
    <section className="epi-card tone-blue">
      <div className="epi-card-head">
        <span className="num">{t('admin.templates.cardHead.num')}</span>
        <span className="title">{t('admin.templates.cardHead.title')}</span>
        <span className="meta">{t('admin.templates.cardHead.meta')}</span>
      </div>
      <TemplatesTab />
    </section>
  );
}
